import { render, staticRenderFns } from "./uploadChoose.vue?vue&type=template&id=d8852fe4&scoped=true&"
import script from "./uploadChoose.vue?vue&type=script&lang=js&"
export * from "./uploadChoose.vue?vue&type=script&lang=js&"
import style0 from "./uploadChoose.vue?vue&type=style&index=0&id=d8852fe4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8852fe4",
  null
  
)

export default component.exports